import Icon from '../../../components/AppIcon';

const colorMap = {
  blue: { bg: 'bg-blue-50', hover: 'hover:bg-blue-100', text: 'text-blue-800', icon: '#3b82f6' },
  green: { bg: 'bg-green-50', hover: 'hover:bg-green-100', text: 'text-green-800', icon: '#10b981' },
  purple: { bg: 'bg-blue-50', hover: 'hover:bg-blue-100', text: 'text-blue-800', icon: '#a855f7' },
  slate: { bg: 'bg-slate-50', hover: 'hover:bg-slate-100', text: 'text-slate-800', icon: '#64748b' },
};

export default function QuickActionCard({ title, icon, color, onClick }) {
  const colors = colorMap?.[color] || colorMap?.blue;

  return (
    <button
      onClick={onClick}
      className={`${colors?.bg} ${colors?.hover} rounded-lg p-4 transition-all duration-200 hover:shadow-md text-right w-full`}
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-sm">
          <Icon name={icon} size={20} color={colors?.icon} />
        </div>
        <span className={`font-medium ${colors?.text}`} style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>
          {title}
        </span>
      </div>
    </button>
  );
}